import { Injectable, Inject, autobind } from '@kaokei/use-vue-service';
import { UserService } from './user.service';
import { useRoute } from 'vue-router';

// 挽留窗口
@Injectable()
export class RetainService {
  route: any = useRoute();
  public userExamId = 0;
  @Inject(UserService)
  public userService!: UserService;

  @autobind
  public initData(data: any) {
    this.userExamId = data.userExamId;
  }

  @autobind
  public initEvent() {
    window.addEventListener('beforeunload', this.showRetainWindow, false);
  }

  @autobind
  public showRetainWindow(e: BeforeUnloadEvent) {
    e.preventDefault();
    const confirmationMessage = '是否确定离开当前页面吗？';
    // Gecko + IE
    (e || window.event).returnValue = confirmationMessage;
    // Webkit, Safari, Chrome etc.
    if (window.hetaoTrack) {
      window.hetaoTrack('element_show', {
        elementName: '赛考页面挽留弹窗',
        userId: this.userService?.user?.userId || 0,
        uniqueId: this.userExamId,
      });
    }
    return confirmationMessage;
  }

  public dispose() {
    window.removeEventListener('beforeunload', this.showRetainWindow, false);
  }
}
